import { StudentReviewTransferCtrl } from './student-review.controller';

export const StudentReviewTransferComponent = {
  controller: StudentReviewTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./student-review.html'),
};
